import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/christmas-badge.png")